<template>
  <div>
    <h1 class="mb-0">Login</h1>
    <p>Use your credentials to login</p>
    <sign-in1-form  v-model:email="email" v-model:password="password"></sign-in1-form>
  </div>
</template>

<script>
import auth0 from 'auth0-js'
import SignIn1Form from './Forms/SignIn1Form'
import constant from '@/config/constant'


export default {
  name: 'SignIn1',
  components: { SignIn1Form },
  data () {
    return{
      email:'',
      password:'',
    }
  },
  mounted () {
    const loggedIn = localStorage.getItem('token')
    if (loggedIn !== undefined && loggedIn !== null) {
      this.$router.push({ name: 'mini.dashboard.home-2' })
    }
  },
  methods: {
    loginOAuth0: function () {
      new auth0.WebAuth(constant.auth0Config).authorize()
    }
  }
}
</script>
